module.exports = __webpack_public_path__ + "img/vehicle-motoguzzi.7f6a7297.png";